import { Box, MaterialUICore } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const StyledBox = styled(Box)({
  border: 'none',
});
